import { AsyncDirective as LitAsyncDirective } from 'lit/async-directive.js';
import { directive } from 'lit/directive.js';
class AsyncDirective extends LitAsyncDirective {
    constructor() {
        super(...arguments);
        this.isDisconnected = false;
        this.handler = (value) => {
            if (this.isDisconnected)
                return;
            this.setValue(value);
        };
    }
    render(pending, initValue) {
        pending.then(this.handler);
        return initValue ?? '';
    }
    disconnected() {
        this.isDisconnected = true;
    }
}
export const async = directive(AsyncDirective);
//# sourceMappingURL=async-directive.js.map